import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=b92fa50e"
import script from "./uploader.vue?vue&type=script&lang=ts"
export * from "./uploader.vue?vue&type=script&lang=ts"
import style0 from "./uploader.vue?vue&type=style&index=0&id=b92fa50e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports